animateHandler = {
    $campaignContentSection: $('.panel-campaign'),
    $animateLayerPinning: $('.animate-layer-pinning'),
    $parallaxStyle1: $('.parallax-style-1'),
    $parallaxStyle2: $('.parallax-style-2'),
    $parallaxStyle3: $('.parallax-style-3'),
    $rightContentContainer: $('.right-content-container'),
    $imageContentAnimate: $('.image-content-animate'),
    $leftContentContainer:  $('.left-content-container'),
    $numberText: $('.number-text'),
    $parallaxContainer: $('.parallax-container'),
    $animateProgress: $('.animate-progress'),
    $animateProgressSmall: $('.animate-progress-small'),
    $carouselContainer: $('.text-carousel-container'),
    

    animateCampaign: function(){
        var self = this;

        gsap.set(self.$rightContentContainer, { zIndex: (i, target, targets) => targets.length - i });
        gsap.set(self.$leftContentContainer, { zIndex: (i, target, targets) => targets.length - i });

        var imagesBg = gsap.utils.toArray('.right-content-container:not(.last)');
        var images = gsap.utils.toArray(self.$imageContentAnimate);
        var texts = gsap.utils.toArray(self.$leftContentContainer);
        var numbText = gsap.utils.toArray(self.$numberText);
        
        imagesBg.forEach((image, i) => {
            var tl = gsap.timeline({
                scrollTrigger: {
                    trigger: self.$campaignContentSection,
                    scroller: "html",
                    start: () => ((window.innerHeight/1.5) * (i+1))+ "px top",
                    end: () => ((window.innerHeight/1.5) * (i+1)),
                    toggleActions: "play none reverse none",
                    invalidateOnRefresh: true,
                }
            })
            tl.to(image, { 
                opacity: 0, 
                ease: "none"
            });
        });

        images.forEach((image, i) => {
            var start = (i == 0) ? "5%" : "top" ;
            var tl = gsap.timeline({
                scrollTrigger: {
                    trigger: self.$campaignContentSection,
                    scroller: "html",
                    start: () => start+" -" + ((window.innerHeight/2.4) * i), 
                    end: () => "+=" + (window.innerHeight),
                    scrub: 0.6,
                    toggleActions: "play none reverse none",
                    invalidateOnRefresh: true,
                    //markers: true     
                }
            })
            if (i > 0) {
                tl.from(image, { 
                    y: "150%",
                    ease: "none"
                });
            }
            
            var finalY = ((i+1) == images.length) ? "-20%"  : "-210%" ;
            tl.to(image, {  
                duration: 1000, 
                y: finalY,
                ease: "none"
            });
        });

        texts.forEach((text, i) => {
            var tl = gsap.timeline({
                scrollTrigger: {
                    trigger: self.$campaignContentSection,
                    scroller: "html",
                    //markers: true,
                    start: () => "top -" + ((window.innerHeight/2.5) * i),
                    end: () => "+=" + (window.innerHeight),
                    scrub: 0.5,
                    toggleActions: "play none reverse none",
                    invalidateOnRefresh: true,     
                    ease: "none"
                }
            })

            if (i > 0) {
                tl.from(text, { 
                    y: "70%",
                    ease: "none"
                });
            }
            
            var finalY = ((i+1) == texts.length) ? "-10%"  : "-80%" ;
            tl.to(text, {  
                duration: 1000, 
                y: finalY,
                ease: "none"
            });
        });

        numbText.forEach((nText, i) => {
            var tl = gsap.timeline({
                scrollTrigger: {
                    trigger: self.$campaignContentSection,
                    scroller: "html",
                    start: () => "top -" + ((window.innerHeight/2.5) * i),
                    end: () => "+=" + window.innerHeight,
                    scrub: 0.7,
                    toggleActions: "play none reverse none",
                    invalidateOnRefresh: true,     
                    ease: "none"
                }
            })
            if (i > 0) {
                tl.from(nText, { 
                    y: "160%",
                });
            }
            
            var finalY = ((i+1) == numbText.length) ? "0"  : "-200%" ;
            tl.to(nText, {  
                duration: 100, 
                y: finalY,
                ease: "none"
            });
        });

        ScrollTrigger.create({
            trigger: self.$campaignContentSection,
            scroller: "html",
            scrub: true,
            pin: true,
            start: () => "top top",
            end: () => "+=" + (((images.length + 1) * (window.innerHeight / 1.5 )) - (window.innerHeight / 2)), 
            invalidateOnRefresh: true,
            toggleActions: "restart pause resume pause",
            ease: "none"
        });
    },

    pinningLayer: function(){
        var self = this;

        gsap.registerPlugin(ScrollTrigger);
        gsap.utils.toArray(self.$animateLayerPinning).forEach((panel, i) => { 
            var endAnchor = ( (i+1) < self.$animateLayerPinning.length ) ? "bottom top" : "top top"; 
            
            ScrollTrigger.create({
                trigger: panel,
                start: "top top", 
                end: endAnchor,
                pin: true, 
                pinSpacing: false,
                //markers: true,
                snap: 1 / 3
            });
        });
    },


    parallaxCreator: function($obj, startY, finishY) {
        var self = this;

        var tl = gsap.timeline({
            yPercent: startY,
            scrollTrigger: {
                trigger: self.$parallaxContainer,
                start: "top 60%",
                end: "150% top",
                scrub: 0.7,
                ease: "none",
                invalidateOnRefresh: true
            }
        });

        tl.to($obj, {
            yPercent: finishY,
            ease: "none",
        });
    },

    parallaxObj: function(){
        var self = this;
        var startStyle1  = 45;
        var finishStyle1 = -70;
        var startStyle2  = 70;
        var finishStyle2 = -150;
        var startStyle3  = 30;
        var finishStyle3 = -90;

        if (Foundation.MediaQuery.atLeast('medium')) {
            startStyle1  = 45;
            finishStyle1 = -80;
            startStyle2  = 45;
            finishStyle2 = -90;
            startStyle3  = 45;
            finishStyle3 = -100;
        }

        this.parallaxCreator(this.$parallaxStyle1, startStyle1, finishStyle1);
        this.parallaxCreator(this.$parallaxStyle2, startStyle2, finishStyle2);
        this.parallaxCreator(this.$parallaxStyle3, startStyle3, finishStyle3);
    },

    progressAnimate: function(){
        var self = this;
        gsap.registerPlugin(ScrollTrigger);
        
        var startAnchor = "70%";
        var $obj = self.$animateProgress; 
        if (Foundation.MediaQuery.only('small')) { 
        //    startAnchor = "30%";
            $obj = self.$animateProgressSmall;
        } 

        $obj.each(function(){
            var $me = $(this);
            gsap.to($me, {
                width: "100%",
                ease: 'none',
                scrollTrigger: { 
                    trigger: $me,
                    start: "top "+startAnchor,
                    end: "bottom 40%",
                    scrub: 0.3 
                }
            });

        })
        
    },

    runningText: function() {
        var self = this;

        if (self.$carouselContainer.length > 0) {
            var $cells = self.$carouselContainer.find('.text-item');

            if ($cells.length > 1) {
                var totalWidth = 0;
                $cells.each(function() {
                    totalWidth += $(this).outerWidth();
                });
            }

            var animationSpeed = 12;
            if (Foundation.MediaQuery.only('small')) {
                animationSpeed = 14;
            }
                
            var boxWidth = $cells.outerWidth() / 3,
                totalWidth = (boxWidth * $cells.length) + 10;

            function marquee(which, time){
                gsap.set(which, {
                    x:function(i) {
                        return i ;
                    }
                });
            
                var action = gsap.timeline()
                .to(which,  {
                    x: "-=" + totalWidth,
                    modifiers: {
                        x: gsap.utils.unitize(x => x % totalWidth),
                    },
                    duration:time, ease:'none',
                    repeat:-1,
                });
                return action
            }

            gsap.timeline().add(marquee($cells, animationSpeed), 1)
        }
    },

    init: function(){
        var self = this;

        this.runningText();
        this.parallaxObj();
        if (Foundation.MediaQuery.atLeast('medium')) {
            this.animateCampaign();
            this.pinningLayer();
        }
        this.progressAnimate();

        //window.dispatchEvent(new Event('resize'));
        
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
            //$(window).trigger('resize');
        }, 500);
    }
}

